module.exports = __webpack_public_path__ + "img/half-round-header-background.c8312e54.svg";